import React from 'react';

import PropTypes from 'prop-types';
import { connect } from 'react-redux';

import AddDenChiefModal from '@modules/advancement/denChiefSearch/components/AddDenChiefModal';
import { isVisibleAddDenChiefModalSel } from '@modules/advancement/denChiefSearch/duck/selectors';
import {
  setPackRosterSearch,
  setPackRosterSorter,
} from '@modules/advancement/packRoster/duck/slice';
import {
  goToAdultProfile,
  goToUnregisteredYouthProfile,
  goToYouthProfile,
  offlineSel,
  sorterPropTypes,
} from '@shared';
import { SearchInput } from '@shared/components';
import { isMobileSel } from '@shared/duck/selectors/general.selectors';
import { intl } from '@shared/localization';

import { AddSubUnitModal } from '../../../subUnits';
import {
  approvedSubUnitsSel,
  subUnitTypeSel,
} from '../../../subUnits/duck/selectors';
import {
  filteredItemsSel,
  isSubUnitAllowedSel,
  itemsPerMemberTypeSel,
  itemsPerOrderStatusSel,
  itemsPerSubUnitSel,
  itemsSel,
  loadingSel,
  packRosterRequestIfNotLoaded,
  selectedKeysSel,
  setSelectedKeys,
  unitRosterReportLoadingSel,
} from '../../duck';
import {
  filterSel,
  isGroupedbyOrderStatusSel,
  searchSel,
  showSubUnitsSel,
  sorterSel,
} from '../../duck/selectorsTyped';
import AddToSubUnitModal from '../AddToSubUnitModal';
import PackRosterList from './PackRosterList';
import PackRosterTable from './PackRosterTable';

class PackRoster extends React.PureComponent {
  state = {
    searchPinned: false,
  };

  componentDidMount() {
    this.props.onFetchRoster();
  }

  handleSearch = search => {
    this.props.onSetSearch(search);
  };

  handleSorterChange = sorter => {
    this.props.onSetSorter(sorter);
  };

  handleSelectedRowKeysChange = selectedRowKeys => {
    this.props.onSetSelectedKeys(selectedRowKeys);
  };

  handleSearchPinChange = searchPinned => this.setState({ searchPinned });

  handleGoToYouthProfile = youth => event => {
    const { userId, isAdult, memberId } = youth;
    if (!isAdult && !this.props.isOffline) {
      event.stopPropagation();
      memberId
        ? this.props.onGoToYouthProfile(userId)
        : this.props.onGoToUnregisteredYouthProfile(userId);
    }
  };

  handleGoToAdultProfile =
    ({ userId, isAdult }) =>
    event => {
      if (isAdult && !this.props.isOffline) {
        event.stopPropagation();
        this.props.onGoToAdultProfile(userId);
      }
    };

  renderSearch() {
    const { search } = this.props;

    return (
      <SearchInput
        key="search"
        id="qa_inputSearchRoster"
        size="large"
        mobileSticky
        placeholder={intl.formatMessage({
          id: 'advancement.PackRoster.search',
        })}
        value={search}
        onChange={this.handleSearch}
        onPinChange={this.handleSearchPinChange}
      />
    );
  }

  renderTable() {
    const {
      loading,
      unitRosterReportLoading,
      isMobile,
      filteredItems,
      items,
      selectedKeys,
      filter,
      sorter,
      isOffline,
      itemsPerSubUnit,
      itemsPerMemberType,
      itemsPerOrderStatus,
      subUnitViewActive,
      subUnitType,
      isSubUnitAllowed,
      approvedSubUnits,
      groupedByOrderStatus,
      search,
    } = this.props;
    const { searchPinned } = this.state;
    const rosterOrReportLoading = loading || unitRosterReportLoading;

    return isMobile ? (
      <PackRosterList
        key="list"
        items={filteredItems}
        itemsPerSubUnit={itemsPerSubUnit}
        selectedItems={selectedKeys}
        rosterReady={!rosterOrReportLoading && items.length > 0}
        loading={rosterOrReportLoading}
        selectedRowKeys={selectedKeys}
        searchPinned={searchPinned}
        sorter={sorter}
        subUnitViewActive={subUnitViewActive}
        filter={filter}
        isOffline={isOffline}
        onSelectedRowKeysChange={this.handleSelectedRowKeysChange}
        onGoToYouthProfile={this.handleGoToYouthProfile}
        onGoToAdultProfile={this.handleGoToAdultProfile}
        subUnitType={subUnitType}
        isSubUnitAllowed={isSubUnitAllowed}
        approvedSubUnits={approvedSubUnits}
      />
    ) : (
      <PackRosterTable
        key="table"
        items={filteredItems}
        itemsPerSubUnit={itemsPerSubUnit}
        itemsPerMemberType={itemsPerMemberType}
        groupedByOrderStatus={groupedByOrderStatus}
        itemsPerOrderStatus={itemsPerOrderStatus}
        subUnitViewActive={subUnitViewActive}
        selectedItems={selectedKeys}
        selectedRowKeys={selectedKeys}
        loading={rosterOrReportLoading}
        sorter={sorter}
        search={search}
        isOffline={isOffline}
        filter={filter}
        onSorterChange={this.handleSorterChange}
        onSelectedRowKeysChange={this.handleSelectedRowKeysChange}
        onGoToYouthProfile={this.handleGoToYouthProfile}
        onGoToAdultProfile={this.handleGoToAdultProfile}
        subUnitType={subUnitType}
        isSubUnitAllowed={isSubUnitAllowed}
        approvedSubUnits={approvedSubUnits}
      />
    );
  }

  render() {
    const { isVisibleAddDenChiefModal } = this.props;
    return (
      <React.Fragment>
        {this.props.isSubUnitAllowed && (
          <>
            <AddSubUnitModal />
            <AddToSubUnitModal />
          </>
        )}
        {isVisibleAddDenChiefModal && <AddDenChiefModal />}
        {this.renderSearch()}
        {this.renderTable()}
      </React.Fragment>
    );
  }
}

PackRoster.propTypes = {
  items: PropTypes.array.isRequired,
  filteredItems: PropTypes.array.isRequired,
  itemsPerSubUnit: PropTypes.array.isRequired,
  itemsPerMemberType: PropTypes.array.isRequired,
  itemsPerOrderStatus: PropTypes.array.isRequired,
  groupedByOrderStatus: PropTypes.bool,
  loading: PropTypes.bool.isRequired,
  unitRosterReportLoading: PropTypes.bool.isRequired,
  selectedKeys: PropTypes.array.isRequired,
  filter: PropTypes.object.isRequired,
  search: PropTypes.string.isRequired,
  isMobile: PropTypes.bool.isRequired,
  sorter: sorterPropTypes,
  isOffline: PropTypes.bool.isRequired,
  subUnitViewActive: PropTypes.bool.isRequired,
  onFetchRoster: PropTypes.func.isRequired,
  onSetSelectedKeys: PropTypes.func.isRequired,
  onSetSearch: PropTypes.func.isRequired,
  onSetSorter: PropTypes.func.isRequired,
  onGoToYouthProfile: PropTypes.func.isRequired,
  onGoToUnregisteredYouthProfile: PropTypes.func.isRequired,
  onGoToAdultProfile: PropTypes.func.isRequired,
  subUnitType: PropTypes.string,
  isSubUnitAllowed: PropTypes.bool.isRequired,
  approvedSubUnits: PropTypes.array,
  isVisibleAddDenChiefModal: PropTypes.bool.isRequired,
};

const mapState = state => ({
  items: itemsSel(state),
  filteredItems: filteredItemsSel(state),
  itemsPerSubUnit: itemsPerSubUnitSel(state),
  itemsPerMemberType: itemsPerMemberTypeSel(state),
  itemsPerOrderStatus: itemsPerOrderStatusSel(state),
  groupedByOrderStatus: isGroupedbyOrderStatusSel(state),
  loading: loadingSel(state),
  unitRosterReportLoading: unitRosterReportLoadingSel(state),
  selectedKeys: selectedKeysSel(state),
  isMobile: isMobileSel(state),
  filter: filterSel(state),
  search: searchSel(state),
  sorter: sorterSel(state),
  isOffline: offlineSel(state),
  subUnitViewActive: showSubUnitsSel(state),
  subUnitType: subUnitTypeSel(state),
  isSubUnitAllowed: isSubUnitAllowedSel(state),
  approvedSubUnits: approvedSubUnitsSel(state),
  isVisibleAddDenChiefModal: isVisibleAddDenChiefModalSel(state),
});

const mapDispatch = dispatch => ({
  onFetchRoster: () => dispatch(packRosterRequestIfNotLoaded()),
  onSetSelectedKeys: keys => dispatch(setSelectedKeys(keys)),
  onSetSearch: search => dispatch(setPackRosterSearch({ search })),
  onSetSorter: sorter => dispatch(setPackRosterSorter({ sorter })),
  onGoToYouthProfile: userId => dispatch(goToYouthProfile(userId)),
  onGoToUnregisteredYouthProfile: userId =>
    dispatch(goToUnregisteredYouthProfile(userId)),
  onGoToAdultProfile: userId => dispatch(goToAdultProfile(userId)),
});

export default connect(mapState, mapDispatch)(PackRoster);
